import React from 'react';
import { Drawer } from '@material-ui/core';
import mapValues from 'lodash.mapvalues';
import Button from '@material-ui/core/Button';
import Error from 'Components/Error';
import Loader from 'Components/Loader';
import Success from 'Components/Success';
import EditProfile from './components/EditProfile';
import EditCompanyInfo from './components/EditCompanyInfo';
import InviteCompanyUsers from './components/InviteCompanyUsers';

// TODO: ovo treba da se izdvoji u posebnu komponentu jer se pojavljuje u obe role
// ( za komaniju i za arup korisnik), ne bi trebalo da se nalazi u folderu demand
import AccSettings from '../SettingsDrawer';

import API from '../../api';
import EditProfileMachine from './stateMachine';

class HeaderDrawer extends React.Component {
  state = {
    viewState: EditProfileMachine.initialState.value,
    profile: null,
    logoPreview: null,
    settings: false,
    avatarWillBeDeleted: false,
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.item !== prevProps.item) {
      if (this.props.item === 'edit_profile') {
        this.setState(
          {
            viewState: EditProfileMachine.initialState.value,
            profile: null,
            logoPreview: null,
          },
          this.getUserProfile
        );
      }
      if (this.props.item === 'edit_company_info') {
        this.setState(
          {
            viewState: EditProfileMachine.initialState.value,
            profile: null,
            logoPreview: null,
          },
          this.getCompanyInfo
        );
      }
      if (this.props.item === 'invite') {
        this.setState(
          {
            viewState: 'idle',
            profile: null,
            logoPreview: null,
          },
          this.getCompanyInfo
        );
      }
      if (this.props.item === 'settings') {
        this.setState({
          viewState: 'idle',
          profile: null,
          logoPreview: null,
          settings: true,
        });
      }
    }
  }

  getUserProfile = () => {
    API.getUserProfile()
      .then(res => {
        this.setState(state => ({
          profile: mapValues(res.data, value => {
            if (!value) {
              return '';
            }
            return value;
          }),
          viewState: EditProfileMachine.transition(
            state.viewState,
            'GET_PROFILE_SUCCESS'
          ).value,
        }));
      })
      .catch(err => {
        this.setState(state => ({
          error: err,
          viewState: EditProfileMachine.transition(state.viewState, 'ERROR')
            .value,
        }));
      });
  };

  updateUserProfile = () => {
    let form = new FormData();
    for (let prop in this.state.profile) {
      if (this.state.profile[prop]) {
        form.append(prop, this.state.profile[prop]);
      }
    }

    API.updateUserProfile(form)
      .then(res => {
        this.setState(
          state => ({
            viewState: EditProfileMachine.transition(state.viewState, 'UPDATED')
              .value,
          }),
          () => {
            this.props.trigerUpdateAvatar(res.data.imageId);
            if (this.state.avatarWillBeDeleted) {
              this.removeImage();
            }
          }
        );
      })
      .catch(err => {
        this.setState(state => ({
          error: err,
          viewState: EditProfileMachine.transition(state.viewState, 'ERROR')
            .value,
        }));
      });
  };

  updateCompanyInfo = () => {
    let form = new FormData();
    for (let prop in this.state.profile) {
      if (prop === 'preferences') {
        form.append(
          'disabledCriteriaIds',
          this.state.profile[prop].reduce((disabledIds, criteria) => {
            if (criteria.enabled === false) {
              disabledIds.push(criteria.criteriaId);
            }
            return disabledIds;
          }, [])
        );
      } else {
        form.append(prop, this.state.profile[prop]);
      }
    }

    API.updateCompanyInfo(form)
      .then(res => {
        this.setState(
          state => ({
            viewState: EditProfileMachine.transition(state.viewState, 'UPDATED')
              .value,
          }),
          () => {
            if (this.state.avatarWillBeDeleted) {
              this.removeLogoImage();
            }
          }
        );
      })
      .catch(err => {
        this.setState(state => ({
          error: err,
          viewState: EditProfileMachine.transition(state.viewState, 'ERROR')
            .value,
        }));
      });
  };

  getCompanyInfo = () => {
    API.getCompanyInfo()
      .then(res => {
        this.setState(state => ({
          profile: mapValues(res.data, value => {
            if (!value) {
              return '';
            }
            return value;
          }),
          viewState: EditProfileMachine.transition(
            state.viewState,
            'GET_PROFILE_SUCCESS'
          ).value,
        }));
      })
      .catch(err => {
        this.setState(state => ({
          error: err,
          viewState: EditProfileMachine.transition(state.viewState, 'ERROR')
            .value,
        }));
      });
  };

  onProfileUpdate = () => {
    this.setState(
      state => ({
        viewState: EditProfileMachine.transition(
          state.viewState,
          'PROFILE_UPDATE'
        ).value,
      }),
      () => {
        if (this.props.item === 'edit_profile') {
          this.updateUserProfile();
        }
        if (this.props.item === 'edit_company_info') {
          this.updateCompanyInfo();
        }
        if (this.props.item === 'invite') {
          this.updateInvite();
        }
        if (this.props.item === 'settings') {
          this.updateInvite();
        }
        return null;
      }
    );
  };

  updateInvite = e => {
    alert('inviteee');
  };

  onFieldUpdate = (region = false) => e => {
    if (this.state.avatarWillBeDeleted) {
      this.setState({ avatarWillBeDeleted: false });
    }

    e.persist();
    let input;
    if (region) {
      input = e.target.name;
    } else {
      input = e.target.getAttribute('name');
    }
    if (
      (input === 'profileImage' || input === 'logo') &&
      e.target.files &&
      e.target.files[0]
    ) {
      if (e.target.files[0].size > 5242880) {
        e.target.value = '';

        return this.setState(state => {
          return {
            ...state,
            viewState: EditProfileMachine.transition(
              state.viewState,
              'PHOTO_SIZE_ERROR'
            ).value,
          };
        });
      }

      const reader = new FileReader();
      reader.onload = readEvent => {
        this.setState(state => {
          return {
            ...state,
            logoPreview: readEvent.target.result,
            profile: {
              ...state.profile,
              [input]: e.target.files[0],
            },
          };
        });
      };
      reader.readAsDataURL(e.target.files[0]);
    } else {
      this.setState(state => ({
        ...state,
        profile: {
          ...state.profile,
          [input]: e.target.value,
        },
      }));
    }
  };

  onNotificationClose = () => {
    this.setState(state => ({
      viewState: EditProfileMachine.transition(state.viewState, 'CONFIRM')
        .value,
    }));
  };

  onErrorCancel = () => {
    this.setState(state => ({
      viewState: EditProfileMachine.transition(state.viewState, 'CANCEL').value,
    }));
  };

  onCriteriaToggle = id => e => {
    e.persist();
    this.setState(state => {
      return {
        ...state,
        profile: {
          ...state.profile,
          preferences: state.profile.preferences.map(criteria => {
            if (criteria.criteriaId === id) {
              return {
                ...criteria,
                enabled: e.target.checked,
              };
            }
            return criteria;
          }),
        },
      };
    });
  };

  toggleDrawer = (side, open) => () => {
    this.setState({
      [side]: open,
    });
    if (!open) {
      this.props.onClose();
    }
  };

  removeImage = () => {
    API.deleteAsset(this.state.profile.imageId)
      .then(res => {
        this.setState(
          state => ({
            viewState: EditProfileMachine.transition(state.viewState, 'UPDATED')
              .value,
            profile: {
              ...this.state.profile,
              imageId: null,
            },
          }),
          () => {
            this.props.trigerUpdateAvatar(null);
            this.setState({ avatarWillBeDeleted: false });
          }
        );
      })
      .catch(err => {
        this.setState(state => ({
          error: err,
          avatarWillBeDeleted: false,
          viewState: EditProfileMachine.transition(state.viewState, 'ERROR')
            .value,
        }));
      });
  };
  removeLogoImage = () => {
    API.deleteAsset(this.state.profile.logoImageId)
      .then(res => {
        this.setState(
          state => ({
            viewState: EditProfileMachine.transition(state.viewState, 'UPDATED')
              .value,
            profile: {
              ...this.state.profile,
              logoImageId: null,
            },
          }),
          () => {
            this.props.trigerUpdateAvatar(null);
            this.setState({ avatarWillBeDeleted: false });
          }
        );
      })
      .catch(err => {
        this.setState(state => ({
          error: err,
          avatarWillBeDeleted: false,
          viewState: EditProfileMachine.transition(state.viewState, 'ERROR')
            .value,
        }));
      });
  };

  onEditProfileClose = () => {
    if (this.state.avatarWillBeDeleted) {
      this.setState({ avatarWillBeDeleted: false });
    }
    this.props.onClose();
  };

  prepareToDeleteAvatar = () => {
    this.setState({ avatarWillBeDeleted: true });
  };

  render() {
    const { role } = this.props;

    return (
      <React.Fragment>
        <Success
          open={this.state.viewState === 'updated'}
          message="Profile updated"
          handleClose={this.onNotificationClose}
        />

        <Drawer
          data-testid="drawer"
          anchor="right"
          open={this.props.open}
          onClose={this.onEditProfileClose}
          classes={{
            paper:
              'bc-gray u-pad-r-60 u-pad-l-60 mw540 t-align-c scroll-y custom-drawer-display-block',
          }}
        >
          {this.state.viewState === 'loading' ? <Loader isLoading /> : null}
          {this.state.viewState === 'error' ? (
            <Error onCancel={this.onErrorCancel} errors={this.state.error} />
          ) : null}

          {this.state.viewState === 'photo_size_error' ? (
            <Error
              onCancel={this.onErrorCancel}
              errors={'Image size cannot be greater then 5 MB'}
            />
          ) : null}

          {this.props.item === 'edit_profile' && this.state.profile ? (
            <EditProfile
              onClose={this.onEditProfileClose}
              profile={this.state.profile}
              onFieldUpdate={this.onFieldUpdate}
              logoPreview={this.state.logoPreview}
              avatarWillBeDeleted={this.state.avatarWillBeDeleted}
              removeImage={this.prepareToDeleteAvatar}
            />
          ) : null}
          {this.props.item === 'edit_company_info' && this.state.profile ? (
            <EditCompanyInfo
              onClose={this.props.onClose}
              profile={this.state.profile}
              onFieldUpdate={this.onFieldUpdate}
              onCriteriaToggle={this.onCriteriaToggle}
              avatarWillBeDeleted={this.state.avatarWillBeDeleted}
              logoPreview={this.state.logoPreview}
              removeImage={this.prepareToDeleteAvatar}
              role={role}
            />
          ) : null}
          {this.props.item === 'invite' ? (
            <InviteCompanyUsers
              onClose={this.props.onClose}
              profile={this.state.profile}
            />
          ) : null}
          {this.props.item === 'settings' ? (
            <AccSettings
              profile={this.state.profile}
              settings={this.state.settings}
              close={this.toggleDrawer('settings', false)}
              open={this.toggleDrawer('settings', true)}
            />
          ) : null}
          {this.props.item !== 'invite' ? (
            <div>
              <Button
                disabled={
                  (this.state.profile !== null &&
                    this.state.profile.regions &&
                    this.state.profile.regions.length === 0) ||
                  this.state.viewState === 'loading'
                    ? true
                    : false
                }
                fullWidth
                data-testid="saveProfile"
                variant="contained"
                color="primary"
                className="t-weight-b pointer u-mrg-right-0 u-mrg-top-60 u-mrg-bot-60"
                onClick={this.onProfileUpdate}
              >
                SAVE
              </Button>
              {this.state.profile !== null &&
                this.state.profile.regions &&
                this.state.profile.regions.length === 0 && (
                  <div>You have to select at least one region</div>
                )}
            </div>
          ) : null}
        </Drawer>
      </React.Fragment>
    );
  }
}

export default HeaderDrawer;
